import React from 'react'

const ControlStrip = ({children}) => {
  return (
    <div className={`py-4 flex items-center ${children.length > 1 ? "justify-between" : "justify-end"} gap-x-4 border-zinc-200 border-b`}>{children}</div>
  )
}

export default ControlStrip